<template>
  <setup-form></setup-form>
</template>

<script>
import SetupForm from "../components/Setup/SetupForm";

export default {
  components: {
    "setup-form": SetupForm
  }
};
</script>

<style>
</style>